// extracted by mini-css-extract-plugin
export default {"root":"Label_root__WLdfO","mainText":"Label_mainText__PgfBT","optionalText":"Label_optionalText__1kb-a","small":"Label_small__x1wTR"};